import React, { useState } from 'react';
import { Box, Toolbar, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#1f1f1f' }}>
      <Sidebar 
        open={sidebarOpen} 
        onToggle={handleSidebarToggle}
        mobileOpen={mobileOpen}
        onMobileToggle={handleMobileToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          transition: 'margin-left 0.3s ease',
          marginLeft: { 
            xs: 0, // No margin on mobile
            md: sidebarOpen ? `${0}px` : '10px' // Margin for sidebar on desktop
          },
        }}
      >
        <Header 
          onMenuClick={handleMobileToggle} 
          sidebarOpen={sidebarOpen} 
        />
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Layout; 